module.exports = function UpdateSourceUpdate(cid, path, update) {
    this.cid = cid;
    this.path = path;
    this.update = update;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update.js
// module id = 544
// module chunks = 1